import React from 'react';
import { components } from 'react-select';
import Icon from '../../../general/Icon';
import { colors } from '../../../../utils/styles/defaultTheme';

const LockIndicator = React.memo((props) => {
    let icon = <Icon name="lockOutline" size="medium" color={colors.grey[500]} />;
    if (props?.selectProps?.lockIcon) {
        icon = props?.selectProps?.lockIcon;
    }
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>{icon}</components.DropdownIndicator>
        )
    );
});

LockIndicator.displayName = 'LockIndicator';

export default LockIndicator;
